import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import NavigationHeader from '../components/NavigationHeader';

export default function SuspendedScreen() {
  return (
    <View style={styles.container}>
      <View style={styles.background} />
      <View style={styles.splashContainer}>
        <NavigationHeader />
        <View style={styles.card}>
          <Text style={styles.title}>Account Suspended</Text>
          <Text style={styles.subtitle}>Your account is currently suspended. If you believe this is a mistake or you would like to appeal, please contact us.</Text>
          <Text style={styles.email}>contact@betoptimized.com</Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#131313' },
  background: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#131313' },
  splashContainer: { flex: 1, paddingHorizontal: Platform.OS === 'web' ? 48 : 24, paddingTop: 32, gap: 24 },
  card: { alignSelf: 'stretch', borderRadius: 12, borderWidth: 1, borderColor: 'rgba(255,255,255,0.14)', backgroundColor: 'rgba(255,255,255,0.04)', padding: 24 },
  title: { color: '#fff', fontSize: 20, fontWeight: '700', marginBottom: 8 },
  subtitle: { color: 'rgba(255,255,255,0.85)' },
  email: { color: '#9fd3ff', marginTop: 12 }
});
